import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import './i18n/i18n' // Import i18n configuration
import { setupDeploymentRecovery } from './lib/setupDeploymentRecovery'
import { initServiceWorker } from './serviceWorkerRegistration'

setupDeploymentRecovery();

createRoot(document.getElementById("root")!).render(
  <App />
);

if (window.isSecureContext) {
  void initServiceWorker();
} else {
  import('./serviceWorkerRegistration').then(({ unregister }) => unregister());
}
